
import { BusinessUnitEmailContactMetadataBase } from './business-unit-email-contact.metadata.base';


export class BusinessUnitEmailContactMetadata extends BusinessUnitEmailContactMetadataBase {
  constructor() {
    super();
  }
}

export const BUSINESS_UNIT_EMAIL_CONTACT_METADATA: BusinessUnitEmailContactMetadata = new BusinessUnitEmailContactMetadata();


